import React, { useState } from "react";
import module from "./SeeQr.module.css";
import { Auth } from "aws-amplify";
import { QRCodeCanvas } from "qrcode.react";
import {
  Button,
  ButtonGroup,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { useEffect } from "react";
import LinkIcon from "@mui/icons-material/Link";
import ReplySharpIcon from "@mui/icons-material/ReplySharp";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";
import CreateQrUrl from "../util/createQrUrl";

const SeeQr = () => {
  const [sub, setSub] = useState(null);
  const accountUrl = CreateQrUrl(sub);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const getSize = () => {
    if (isMd) {
      return 500;
    }
    if (isXs) {
      return 250;
    }
    return 400;
  };

  const getUserInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setSub(user.attributes.sub);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "#38bf66";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const EachButton = ({ text, icon, handleClick }) => {
    return (
      <Button
        sx={{
          fontSize: "8px",
          width: "145px",
          fontWeight: "bold",
          color: "#38bf66",
          backgroundColor: "white",
        }}
        onClick={handleClick}
      >
        <div>
          <div>{icon}</div>
          <div>{text}</div>
        </div>
      </Button>
    );
  };

  const handleClickCopy = async () => {
    try {
      await navigator.clipboard.writeText(accountUrl);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickShare = () => {
    const shareData = {
      title: "nosh紹介QRコード",
      text: "手軽にヘルシーな食事ナッシュはコチラ",
      url: accountUrl,
    };
    if (navigator.share && navigator.canShare(shareData)) {
      navigator.share(shareData);
    } else {
      alert("申し訳ありませんが、このブラウザではシェアできません。");
    }
  };

  return (
    <div className={module.container}>
      <div>
        <h1 className={module.title}>お客様専用紹介コード</h1>
        <p>QRコードを紹介する方に読み取ってもらってください</p>
      </div>
      <div className={module.card}>
        <div>
          {sub ? (
            <QRCodeCanvas value={accountUrl} size={getSize()} id="account_qr" />
          ) : (
            <CircularProgress color="success" />
          )}
        </div>
      </div>
      <div className={module.wrapButtonGroup}>
        <ButtonGroup
          variant="contained"
          aria-label="outlined primary button group"
        >
          <EachButton
            text="リンクをコピー"
            icon={<LinkIcon />}
            handleClick={handleClickCopy}
          />
          <EachButton
            text="シェア"
            icon={<ReplySharpIcon />}
            handleClick={handleClickShare}
          />
        </ButtonGroup>
      </div>
      <div>
        <Button
          variant="outlined"
          sx={{
            color: "white",
            borderColor: "white",
            padding: "4px 24px",
            fontWeight: "bold",
          }}
          LinkComponent={Link}
          to="/mypage/accounts"
        >
          戻る
        </Button>
      </div>
    </div>
  );
};

export default SeeQr;
